// extracted by mini-css-extract-plugin
export default {"LinkIcon":"ServiceProvider_LinkIcon__UQotH","linkContainer":"ServiceProvider_linkContainer__kJakb"};